import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatExpansionModule} from '@angular/material/expansion';
import { ActionTaxonomyCategoryComponent } from '../action-plan-panel/action-taxonomy-category.component';
import { TitleComponent } from '../title/title.component';

@Component({
  selector: 'kla-action-plan-taxanomy',
  templateUrl: './action-plan-taxanomy.component.html',
  styleUrls: ['./action-plan-taxanomy.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, ActionTaxonomyCategoryComponent, TitleComponent ]
})
export class ActionPlanTaxanomyComponent implements OnInit {

  panels: string[];
  categories: any[];
  @Input() config: any;
  @Input() lineConfig: any;
  @Input() collapseChildren = false;

  ngOnInit() {
    const jsonPanels: string[] = [];
    const categories: any[] = [];
    const onlyVisiblePanels = (this.config.list as Array<any>).filter(x => x.isVisible);
    onlyVisiblePanels.forEach(panel => {
      jsonPanels.push(JSON.stringify(panel)); /* we are doing this to avoid out of memory error, because the objects are too large */
    });

    const allPanels = this.config.list;
    allPanels.forEach(panel => {
      categories.push({
        color: panel.color,
        imageId: panel.imageId ? panel.imageId : '',
        title: panel.title
      });
    });

    this.categories = categories;
    this.panels = jsonPanels;
  }
}
